import request from '@/utils/request.js'

export function getcartlist(data) {
  return request.get('/api/H5/shoppingcart/getcartlist', {
    params: data
  })
}

export function addcart(data) {
  return request.get('/api/H5/shoppingcart/addcart', {
    params: data
  })
}

export function addcartbyproduct(data) {
  return request.get('/api/H5/shoppingcart/addcartbyproduct', {
    params: data
  })
}

export function delcart(data) {
  return request.get('/api/H5/shoppingcart/delcart', {
    params: data
  })
}

export function getcartTreelist(data) {
  return request.get('/api/H5/shoppingcart/getcartTreelist', {
    params: data
  })
}
